/* eslint-disable max-len */

/**
 * Whatsapp Icon Component
 * @return {ReactElement}
 */
export const SocialWhatsappIcon = () => {
    return (
        <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.335938 13.7029L1.28294 10.2698C0.699886 9.26071 0.393413 8.11566 0.394476 6.95025C0.395538 5.78485 0.704097 4.64036 1.28899 3.63236C1.87389 2.62436 2.71441 1.78855 3.72568 1.20932C4.73695 0.630094 5.88315 0.327966 7.04854 0.333447C8.05826 0.334713 9.05435 0.566623 9.9608 1.01148C10.8672 1.45633 11.6601 2.10238 12.2788 2.90031C12.8976 3.69824 13.3259 4.62698 13.531 5.61564C13.7362 6.6043 13.7127 7.62676 13.4626 8.605C13.2124 9.58324 12.742 10.4914 12.0874 11.2602C11.4328 12.0289 10.6112 12.638 9.68536 13.0409C8.75951 13.4438 7.75385 13.6299 6.74512 13.585C5.7364 13.54 4.75128 13.2652 3.86493 12.7816L0.335938 13.7029ZM4.02815 11.5822C4.92837 12.1597 5.9751 12.4675 7.04464 12.4691C8.27411 12.4629 9.46612 12.0453 10.4305 11.2827C11.395 10.5201 12.0762 9.45653 12.3657 8.26161C12.6552 7.06669 12.5362 5.80925 12.0277 4.68984C11.5192 3.57044 10.6505 2.65356 9.56014 2.08544C8.46978 1.51732 7.22059 1.33068 6.01179 1.5553C4.803 1.77992 3.70424 2.40286 2.89077 3.32476C2.07729 4.24666 1.59596 5.41441 1.52354 6.64176C1.45112 7.86911 1.79179 9.08536 2.49121 10.0965L1.93415 12.1287L4.0287 11.5822H4.02815ZM10.4015 8.53842C10.3603 8.46934 10.2494 8.42701 10.0823 8.34512C9.91518 8.26323 9.09853 7.86159 8.94534 7.80644C8.79215 7.75129 8.68241 7.72344 8.57099 7.88944C8.45958 8.05545 8.14094 8.42812 8.04457 8.53842C7.9482 8.64872 7.85015 8.66265 7.68415 8.57964C7.19422 8.38535 6.74183 8.10732 6.3472 7.75798C5.98367 7.42358 5.67184 7.03703 5.42192 6.61098C5.32499 6.44387 5.41189 6.35585 5.49489 6.2734C5.5779 6.19096 5.66201 6.0801 5.74446 5.98317C5.81358 5.90009 5.86991 5.80715 5.91158 5.70743C5.93375 5.66176 5.9441 5.61125 5.94167 5.56054C5.93923 5.50982 5.9241 5.46054 5.89765 5.4172C5.85587 5.33475 5.5233 4.51977 5.38515 4.18832C5.24979 3.86578 5.11275 3.90979 5.01081 3.90422L4.69161 3.89865C4.60705 3.90056 4.5238 3.91996 4.4471 3.95562C4.3704 3.99129 4.30192 4.04245 4.24596 4.10587C4.05856 4.28306 3.91019 4.4974 3.81034 4.73518C3.71049 4.97297 3.66135 5.22897 3.66606 5.48683C3.72046 6.11167 3.95651 6.70693 4.34512 7.19924C5.05955 8.26451 6.03855 9.12584 7.18614 9.69878C7.49551 9.83145 7.81161 9.94785 8.13314 10.0475C8.47266 10.15 8.83131 10.1725 9.18098 10.1132C9.41229 10.0665 9.63145 9.97241 9.82471 9.83696C10.018 9.70151 10.1811 9.52759 10.304 9.32611C10.4131 9.07881 10.4469 8.8048 10.4009 8.53842H10.4015Z'
                fill='black'
            />
        </svg>
    )
}

/**
 * Facebook Icon Component
 * @return {ReactElement}
 */
export const SocialFacebookIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M14.6693 8.04029C14.6693 4.33616 11.6845 1.33337 8.0026 1.33337C4.3207 1.33337 1.33594 4.33616 1.33594 8.04029C1.33594 11.3878 3.77383 14.1626 6.96094 14.6657V9.979H5.26823V8.04029H6.96094V6.56267C6.96094 4.88175 7.95625 3.95326 9.47904 3.95326C10.2082 3.95326 10.9714 4.08426 10.9714 4.08426V5.73479H10.1307C9.3026 5.73479 9.04427 6.25182 9.04427 6.78274V8.04029H10.8932L10.5977 9.979H9.04427V14.6657C12.2314 14.1626 14.6693 11.3878 14.6693 8.04029Z'
                fill='black'
            />
            <path
                d='M10.5951 9.97174L10.8906 8.03029H9.04167V6.77097C9.04167 6.23983 9.3 5.72154 10.1281 5.72154H10.9688V4.06868C10.9688 4.06868 10.2059 3.9375 9.47643 3.9375C7.95365 3.9375 6.95833 4.8673 6.95833 6.55059V8.03029H5.26562V9.97174H6.95833V14.6651C7.64858 14.7739 8.35142 14.7739 9.04167 14.6651V9.97174H10.5951Z'
                fill='white'
            />
        </svg>
    )
}

/**
 * X Icon Component
 * @return {ReactElement}
 */
export const SocialXIcon = () => {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.10046 6.97913L13.9574 1.33337H12.8064L8.58918 6.23551L5.22088 1.33337H1.33594L6.42947 8.74626L1.33594 14.6667H2.48693L6.94046 9.48989L10.4976 14.6667H14.3826L9.10017 6.97913H9.10046ZM7.52401 8.81157L7.00793 8.07342L2.90165 2.19983H4.66952L7.98333 6.94L8.49941 7.67816L12.807 13.8397H11.0391L7.52401 8.81186V8.81157Z'
                fill='black'
            />
        </svg>
    )
}

/**
 * LinkedIn Icon Component
 * @return {ReactElement}
 */
export const SocialLinkedInIcon = () => {
    return (
        <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.694 0.33355H1.32674C1.19856 0.331113 1.07118 0.354045 0.9519 0.401025C0.832623 0.448005 0.723814 0.518103 0.631731 0.607292C0.539648 0.696481 0.466107 0.803002 0.415344 0.920718C0.36458 1.03843 0.337594 1.16503 0.335938 1.29321V12.703C0.337223 12.8314 0.363938 12.9583 0.414536 13.0763C0.465134 13.1944 0.538613 13.3012 0.630733 13.3907C0.722854 13.4802 0.831792 13.5506 0.951252 13.5977C1.07071 13.6449 1.19833 13.6679 1.32674 13.6655H12.6884C12.8166 13.6673 12.944 13.6439 13.0632 13.5966C13.1824 13.5492 13.2911 13.4788 13.3831 13.3895C13.4752 13.3001 13.5487 13.1934 13.5994 13.0757C13.6502 12.9579 13.6773 12.8312 13.6792 12.703V1.29321C13.6771 1.16514 13.6499 1.03872 13.599 0.921172C13.5481 0.803626 13.4746 0.697255 13.3826 0.608139C13.2906 0.519023 13.1819 0.448905 13.0628 0.40179C12.9437 0.354675 12.8164 0.331489 12.6884 0.33355H12.694ZM2.31895 5.33143H4.30055V11.6938H2.31895V5.33143ZM3.30975 4.46235C3.083 4.46235 2.86133 4.39511 2.67279 4.26913C2.48425 4.14315 2.3373 3.9641 2.25053 3.7546C2.16375 3.54511 2.14105 3.31459 2.18529 3.09219C2.22952 2.86979 2.33872 2.6655 2.49906 2.50516C2.6594 2.34482 2.86368 2.23563 3.08608 2.19139C3.30848 2.14715 3.539 2.16986 3.7485 2.25663C3.95799 2.34341 4.13705 2.49036 4.26303 2.6789C4.38901 2.86744 4.45625 3.0891 4.45625 3.31586C4.4555 3.61968 4.33418 3.91079 4.11895 4.12522C3.90371 4.33966 3.61216 4.4599 3.30834 4.45952L3.30975 4.46235ZM11.7047 11.6938H9.72306V8.59965C9.72306 7.86221 9.7089 6.91246 8.69545 6.91246C7.68201 6.91246 7.50933 7.71642 7.50933 8.54728V11.6938H5.52773V5.33143H7.4244V6.2005H7.45129C7.71598 5.70085 8.36141 5.1729 9.32249 5.1729C11.3239 5.1729 11.6933 6.49066 11.6933 8.20474L11.7047 11.6938Z'
                fill='black'
            />
        </svg>
    )
}
